<script setup lang="ts">
import { GlobeIcon, LocationMarkerIcon } from '@heroicons/vue/solid'
import { initLegalAccountForm } from '../../../../utilities/account/useAccountFormLegal'
import { useLegalAccountDataState } from '../../../../utilities/account/useAccountDataLegal'
import BaseInputText from '../../../base/BaseInputText.vue'
import { getSelectableCountryCodes } from '../../../../data'
import BaseInputCombobox from '../../../base/BaseInputCombobox.vue'
import {
    isRequiredLegalProfileAttributesForInvestment,
    isRequiredRequiredLegalProfileAttributes,
} from '../../../../validation'

const { legalProfile } = useLegalAccountDataState()

initLegalAccountForm('Address Data')
</script>

<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-8 px-4 py-5 sm:grid-cols-2 sm:px-6">
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.address"
                :icon="LocationMarkerIcon"
                :required="isRequiredRequiredLegalProfileAttributes('address')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('address')"
                name="legal_account.address"
                :label="$t('legal_account.address')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.postal_code"
                :icon="LocationMarkerIcon"
                :required="isRequiredRequiredLegalProfileAttributes('postal_code')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('postal_code')"
                name="legal_account.postal_code"
                :label="$t('legal_account.postal_code')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.city"
                :icon="LocationMarkerIcon"
                :required="isRequiredRequiredLegalProfileAttributes('city')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('city')"
                name="legal_account.city"
                :label="$t('legal_account.city')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputText
                v-model="legalProfile.state"
                :icon="LocationMarkerIcon"
                :required="isRequiredRequiredLegalProfileAttributes('state')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('state')"
                name="legal_account.state"
                :label="$t('legal_account.state')" />
        </div>
        <div class="sm:col-span-1">
            <BaseInputCombobox
                v-model="legalProfile.country"
                :icon="GlobeIcon"
                :required="isRequiredRequiredLegalProfileAttributes('country')"
                :required-2="isRequiredLegalProfileAttributesForInvestment('country')"
                name="legal_account.country"
                :options="getSelectableCountryCodes()"
                nullable
                :label="$t('legal_account.country')" />
        </div>
    </div>
</template>
